<p-toast></p-toast>
<p-tabView  [activeIndex]="activeTab" [scrollable]="true" (onChange)="handleChange($event.index)"
    [style]="{'margin-top':'20px'}">
    <p-tabPanel >
        <ng-template pTemplate="header">
            <i style="height: 70px;" class="pi pi-circle-on">
                <h5>{{ 'PANELCOMPCHAT_ALL' | translate}}</h5>
            </i>
        </ng-template>
        <app-chat-list [data]="chats" [newConversation]="newConversation"></app-chat-list>
    </p-tabPanel>

    <p-tabPanel *ngFor="let statu of estatus">
        <ng-template pTemplate="header">
            <i style="height: 70px;" class="{{statu.icon}}">
                <h5>{{statu.name}}</h5>
            </i>
        </ng-template>
        <app-chat-list [data]="chats" [newConversation]="newConversation"></app-chat-list>
    </p-tabPanel>

</p-tabView>